<template>
    <div :class="`product-input ${ viewMode === 'primary' ? 'col-5 custom-resize' : 'col-6' } d-flex`">
        <app-input
            class="mr-2"
            style="flex: 1;"
            v-if="selectedCustomer"
            type="search-and-select"
            :placeholder="$placeholder('customer')"
            @input="handleCustomerInput"
            :options="customerOptions"
            :inputclearable="false"
            list-value-field="value"
            v-model="selectedCustomer"
            :key="customerInputKey"
        />
        <app-input
            v-else
            type="text"
            :placeholder="$placeholder('customer')"
            v-model="selectedCustomer"
        />
        <!-- Add-patient from POS is disabled: patients must be created via the
             Patients module (which enforces the full patient rules). -->
    </div>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {axiosGet, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {SELECTABLE_CUSTOMERS, GET_CUSTOMER_DETAILS} from "../../../Config/ApiUrl-CP";
import {mapGetters, mapMutations, mapActions} from "vuex";

export default {
    mixins: [FormHelperMixins],
    name: 'CustomerInput',
    props: ['viewMode'],
    data() {
        return {
            isModalActive: false,
            selectedCustomer: '',
            branchid:null,
            customerInputKey:0,
            lastAutoCustomer: null,
        }
    },
    methods: {
        ...mapMutations(['SET_SELECTED_CUSTOMER', 'SET_CASH_REGISTER_ID']),
        ...mapActions(['setBranchOrWarehouseId', 'setBranchOrWarehouseName']),
        handleCustomerInput() {
            this.SET_SELECTED_CUSTOMER(this.selectedCustomer);
            this.autoSetBranchForPatient(this.selectedCustomer);
        },
        /**
         * Point the POS at the patient's CURRENT branch. SalesView watches the branch
         * change and opens that branch's cash counter silently (creating one if none
         * exists), so we only switch the branch here — no cash-counter calls, to avoid
         * a double-open conflict. When switching branches we clear any previously-open
         * register so SalesView opens the correct one for the new branch.
         */
        async autoSetBranchForPatient(customerId) {
            if (!customerId || this.lastAutoCustomer === customerId) return;
            this.lastAutoCustomer = customerId;
            try {
                const { data: cust } = await axiosGet(GET_CUSTOMER_DETAILS + customerId);
                // Prefer current_branch; legacy records with no current_branch fall back
                // to original_branch (and its name comes from the `branch` relation).
                const useCurrent = !!(cust && cust.current_branch);
                const branchId = useCurrent ? cust.current_branch : (cust && cust.original_branch);
                if (!branchId || String(this.getBranchOrWarehouseId) === String(branchId)) return;
                const branchName = useCurrent
                    ? (cust.current_branch_info && cust.current_branch_info.name)
                    : (cust.branch && cust.branch.name);

                // Clear any register carried over from a different branch so SalesView
                // opens the right one for this branch (removeItem, not setCashRegisterId,
                // which would store the string "null").
                localStorage.removeItem('cash_register_id');
                this.SET_CASH_REGISTER_ID(null);

                this.setBranchOrWarehouseId(branchId);
                if (branchName) {
                    this.setBranchOrWarehouseName(branchName);
                    localStorage.setItem('currentBranchWahrehouseName', branchName);
                }
                localStorage.setItem('currentBranchWahrehouseId', branchId);
            } catch (e) {
                console.error('Auto branch setup failed', e);
            }
        }
    },
    watch:{
        'getBranchOrWarehouseId': {
            handler(newId) {
                this.branchid = newId;
                this.customerInputKey++;
            }
        }
    },
    computed: {
        ...mapGetters(['getSelectedCustomer','getBranchOrWarehouseId']),
        customerOptions() {
            return {
                url: urlGenerator(SELECTABLE_CUSTOMERS),
                query_name: "search",
                params: {
                    branchid: this.branchid,
                },
                per_page: 10,
                loader: "app-pre-loader", // by default 'app-overlay-loader'
                modifire: ({id, full_name: value}) => ({id, value}), prefetch: false
            }
        },
    },
    mounted() {
        let patientId = this.getQueryStringValue("patient");
        this.selectedCustomer = patientId || (this.getSelectedCustomer || 1);
        // When arriving from a patient's "Place Order", align the POS branch and
        // cash counter to that patient automatically.
        if (patientId) {
            this.SET_SELECTED_CUSTOMER(this.selectedCustomer);
            this.autoSetBranchForPatient(this.selectedCustomer);
        }
    }
}
</script>
